import React, { FC } from 'react';

import styled from '@emotion/styled';
import { mqMax } from '@lucid/theme';

export type ContainerTypeTags = 'div' | 'section' | 'header' | 'main';

export interface ContainerProps {
  /** Sets the HTML tag for the Container component. */
  as?: ContainerTypeTags;
  /** Allows the component to get additional styles. */
  className?: string;
  /** Changes the padding of the Container. */
  customPadding?: number;
  /** Adds additional padding to the Container. */
  extraPadding?: number;
  /** Sets display: 'flex' on the Container. */
  flex?: boolean;
  /** Removes the side padding on the Container. */
  noSidePadding?: boolean;
  /** Sets the HTML id for the Container. */
  id?: string;
}

const StyledContainer: FC<ContainerProps> = styled.div(
  ({ customPadding, noSidePadding, extraPadding, flex }) => ({
    label: 'container',
    display: flex ? 'flex' : 'block',
    position: 'relative',
    maxWidth: '90rem',
    width: '100%',
    margin: '0 auto',
    padding: noSidePadding
      ? 0
      : extraPadding
        ? `0 ${customPadding
          ? customPadding
          : 7.5 + extraPadding}rem`
        : `0 ${customPadding
          ? `${customPadding}rem`
          : '7.5rem'}`,
    WebkitFontSmoothing: 'antialiased',
    justifyContent: 'space-between',
    [mqMax.computer]: {
      paddingLeft: noSidePadding ? 0 : '3.75rem',
      paddingRight: noSidePadding ? 0 : '3.75rem'
    },
    [mqMax.tabletSmall]: {
      paddingLeft: noSidePadding ? 0 : '1.875rem',
      paddingRight: noSidePadding ? 0 : '1.875rem'
    }
  })
);

const Container: FC<ContainerProps> = (props) => <StyledContainer {...props} />;

export { Container };
export default Container;
